import { Helmet } from 'react-helmet-async';

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": "https://stayingahead.club/#website",
      url: "https://stayingahead.club",
      name: "Staying Ahead",
      description:
        "Join 100,000+ professionals getting curated AI updates, tools, and live sessions on WhatsApp. Your unfair advantage in AI.",
      publisher: {
        "@id": "https://stayingahead.club/#organization",
      },
      inLanguage: "en-US",
    },
    {
      "@type": "Organization",
      "@id": "https://stayingahead.club/#organization",
      name: "Staying Ahead",
      url: "https://stayingahead.club",
      description:
        "Free AI community delivering curated updates, resources, and live sessions via WhatsApp.",
      founder: {
        "@type": "Person",
        name: "Vaibhav Sisinty",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://stayingahead.club/#webpage",
      url: "https://stayingahead.club",
      name: "Staying Ahead | Free AI Community on WhatsApp",
      isPartOf: {
        "@id": "https://stayingahead.club/#website",
      },
      about: {
        "@id": "https://stayingahead.club/#organization",
      },
      description:
        "Join 100,000+ professionals getting curated AI updates, tools, and live sessions on WhatsApp. Your unfair advantage in AI.",
      inLanguage: "en-US",
    },
    {
      "@type": "Course",
      name: "Free Weekend AI Masterclass",
      description:
        "Live online AI masterclass sessions every Saturday & Sunday. Learn practical AI skills from industry experts.",
      provider: {
        "@id": "https://stayingahead.club/#organization",
      },
      courseMode: "online",
      educationalLevel: "Beginner to Advanced",
      isAccessibleForFree: true,
      availableLanguage: "en",
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is Staying Ahead?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Staying Ahead is a free AI community on WhatsApp where 100,000+ professionals get curated AI updates, tools, resources, and access to live masterclass sessions.",
          },
        },
        {
          "@type": "Question",
          name: "Is it really free?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, Staying Ahead is completely free forever. No hidden costs, no credit card required.",
          },
        },
        {
          "@type": "Question",
          name: "How do I join?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Simply fill out the form on our website with your details, and you'll be instantly redirected to join the WhatsApp community.",
          },
        },
      ],
    },
  ],
};

export default function SEO() {
  return (
    <Helmet>
      <title>Staying Ahead | Free AI Community on WhatsApp</title>
      <meta name="description" content="Join 100,000+ professionals getting curated AI updates, tools, and live sessions on WhatsApp. Your unfair advantage in AI. Free forever." />
      <meta name="keywords" content="AI community, AI updates, artificial intelligence, WhatsApp AI community, AI news, AI tools, AI learning, AI masterclass, staying ahead, AI resources, machine learning, ChatGPT, generative AI, AI for professionals, free AI course" />
      <meta name="author" content="Vaibhav Sisinty, Staying Ahead" />
      <meta name="creator" content="Staying Ahead" />
      <meta name="publisher" content="Staying Ahead" />
      <link rel="canonical" href="https://stayingahead.club" />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://stayingahead.club" />
      <meta property="og:site_name" content="Staying Ahead" />
      <meta property="og:title" content="Staying Ahead | Free AI Community on WhatsApp" />
      <meta property="og:description" content="Join 100,000+ professionals getting curated AI updates, tools, and live sessions on WhatsApp. Your unfair advantage in AI." />
      <meta property="og:image" content="https://stayingahead.club/og-image.png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Staying Ahead - Free AI Community" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Staying Ahead | Free AI Community on WhatsApp" />
      <meta name="twitter:description" content="Join 100,000+ professionals getting curated AI updates, tools, and live sessions on WhatsApp. Your unfair advantage in AI." />
      <meta name="twitter:image" content="https://stayingahead.club/og-image.png" />
      
      {/* Robots */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
}
